export default function About() {
  return (
    <section id="about">
      <div className="about-visual">
        <div className="about-visual-accent">
          <p>"Where Every Moment Crowns Itself"</p>
          <span>Arch &amp; Crown Events · Est. 2025</span>
        </div>
      </div>

      <div className="about-content">
        <div className="reveal">
          <div className="sec-label">01 — Our Story</div>
          <h2 className="sec-title">
            Two visionaries.<br />
            <em>One shared passion.</em>
          </h2>
        </div>

        <p className="about-body reveal reveal-delay-1">
          Founded by Abhinav and Charan, Arch &amp; Crown Events was born from
          a simple belief — that{" "}
          <em style={{ fontFamily: "Cormorant Garamond, serif", fontStyle: "italic", color: "var(--gold)" }}>
            every family deserves a beautifully planned celebration
          </em>,
          not just those with big budgets.
          <br /><br />
          We handle everything from grand weddings to intimate birthday parties,
          engagement ceremonies, corporate gatherings, and every celebration in between.
          Our mission is to deliver the same quality, care, and creativity — regardless of your budget.
        </p>

        <div className="about-stats reveal reveal-delay-2">
          <div className="stat-item">
            <div className="stat-num">Curated</div>
            <div className="stat-label">Events Planned</div>
          </div>

          <div className="stat-item">
            <div className="stat-num">5★</div>
            <div className="stat-label">Client Rating</div>
          </div>

          <div className="stat-item">
<div className="stat-num">Premium</div>
<div className="stat-label">Vendor Network</div>
          </div>
        </div>
      </div>
    </section>
  );
}